export default from './post-edit-page';



// WEBPACK FOOTER //
// ./app/containers/post-edit-page/index.js